import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import { IMGIX_URL } from '@src/env';

const COMPANY_ALT_TEXT =
  'Logos for various companies, including Microsoft, Apple, Google, OpenAI, Meta, and more';

const Companies = () => {
  return (
    <div className="mt-24 sm:mt-32 lg:mt-48">
      <LazyImgixImage
        alt={COMPANY_ALT_TEXT}
        className="h-auto w-full sm:hidden"
        src={`${IMGIX_URL}/global/subscribe/MOBILE_LOGO_GROUP.png`}
      />
      <LazyImgixImage
        alt={COMPANY_ALT_TEXT}
        className="hidden h-auto w-full sm:block"
        src={`${IMGIX_URL}/global/subscribe/LOGO_GROUP.png`}
      />
    </div>
  );
};

export default Companies;
